import type { ActionItem } from 'shared/ui'
import { truthy } from 'shared/lib'
import {
  type ICallingListResponse,
  type IResponseFullAICallingAgent,
} from 'entities/AICalling/api/types'
import { edit } from './edit/edit'
import { details } from './details/details'
import { deleteAction } from './delete/delete'
import { toggleActive } from './toggleActive/toggleActive'
import { duplicate } from './duplicate/duplicate'

export const getCallingActions = ({
  item,
  onSuccessDelete,
  onSuccessUpdate,
}: {
  item: ICallingListResponse
  onSuccessDelete: () => void
  onSuccessUpdate: (response: IResponseFullAICallingAgent) => void
}): ActionItem[] => {
  return [
    item.status !== 'draft' && toggleActive(item, onSuccessUpdate),
    edit(item),
    details(item),
    duplicate(item),
    deleteAction(item, onSuccessDelete),
  ].filter(truthy)
}
